import React from "react";

function LogoPocket() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="76.346"
      height="10mm"
      version="1.1"
      viewBox="0 0 20.2 10"
    >
      <g
        fillRule="evenodd"
        stroke="none"
        strokeDasharray="none"
        strokeMiterlimit="4"
        strokeOpacity="1"
        paintOrder="normal"
      >
        <rect
          width="19.945"
          height="9.766"
          x="0.186"
          y="0.109"
          fill="#fff"
          strokeWidth="0.2"
          rx="3.044"
          ry="3.372"
        ></rect>
        <path
          fill="#000"
          fillOpacity="1"
          strokeWidth="1.002"
          d="M291.02 304.286l-10.675 6.163-10.675 6.163V291.96l10.675 6.163z"
          transform="matrix(.18313 0 0 .18313 -41.227 -50.731)"
        ></path>
      </g>
    </svg>
  );
}

export default LogoPocket;
